import { Link } from 'react-router-dom';
import { Stack, Typography } from 'ui';

import { useAllDealInspections } from '../../hooks/useAllDealInspections/useAllDealInspections';

export const DealInspectionsList = ({ dealId }: { dealId: number }) => {
  const { data: inspections, isLoading } = useAllDealInspections(dealId);

  if (isLoading) {
    return <Typography variant="body2">Loading related inspections...</Typography>;
  }

  if (!inspections?.data.length) {
    return <Typography variant="body2">No related inspections</Typography>;
  }

  return (
    <Stack direction="row" spacing={2} useFlexGap flexWrap="wrap" data-testid="deal-inspections-list">
      {inspections.data.map(({ id, slug }) => (
        <Link key={id} to={`/ground-control/inspections/${id}/`}>
          {slug}
        </Link>
      ))}
    </Stack>
  );
};
